/** @module csi/page/FullScreenHeader */
define([
	"dojo/_base/declare",
	"dijit/_TemplatedMixin",
	"dijit/_WidgetBase",
	"dijit/_WidgetsInTemplateMixin",
	"csi/html",
	"csi/page",
	"csi/state/rootStore",
	"csi/util",
	"dojo/text!csi/templates/fullscreenHeader.html",

	"csi/widget/Logo"
], function(declare, _TemplatedMixin, _WidgetBase, _WidgetsInTemplateMixin, html, page, {browserStore, routerStore, watchStoreProperty}, util, template) {

	const DURATION = 250;
	const NO_DURATION = 0;
	const CSS_FULLSCREEN = "csi-fullscreen";
	const CSS_FULLSCREEN_CONTAINER = "csi-fullscreen-container";
	const CSS_FULLSCREEN_FIRST = "csi-fullscreen-first";
	const CSS_FULLSCREEN_HIDE = "csi-fullscreen-hide";

	/**
	 * Hide sibling elements of given element
	 * @param {HTMLElement} element 
	 */
	function hideSiblings(element) {
		for (const child of element.parentNode.children) {
			if (child !== element) {
				child.classList.add(CSS_FULLSCREEN_HIDE);
			}
		}
	}

	/**
	 * Resize the page to prevent tabs collapse if user switch to browser full screen while in application's full screen C8-19669 
	 */
	async function _resize(widget) {
		await util.wait(300);
		page.resize();

		// refresh svg toolbar if needed
		const {canvasWidgetNode} = widget.view;
		canvasWidgetNode && canvasWidgetNode.updateToolbar();
	}

	return declare([_WidgetBase, _TemplatedMixin, _WidgetsInTemplateMixin], {
		templateString: template,

		title: "",
		_setTitleAttr: {node: "titleNode", type: "innerText"},

		icon: "",
		_setIconAttr: {node: "iconNode", type: "class"},

		view: null,
		scrollY: null,
		scrollX: null,

		/** @property {ViewWidget[]} flexHeightViews - views forced to flex height */
		flexHeightViews: null,

		/**
		 * Exit the full screen mode
		 */
		_exitFullScreenMode: function() {
			browserStore.exitFullScreen();
		},

		/**
		 * React to leaving full screen mode
		 */
		_onExitFullScreenMode: function() {
			const {classList} = document.body;

			classList.remove(CSS_FULLSCREEN);

			if (routerStore.renderBreadcrumb) {
				$("#pageBreadcrumb").slideDown(DURATION);
			}

			$(".dijitTabController").slideDown(DURATION);
			$("#pageHeader, .csi-toolbar-btn-fullScreen").fadeIn(DURATION, () => {
				classList.remove(CSS_FULLSCREEN_FIRST);
				this.destroy();
				this._showOtherViews();
				_resize(this);

				const scrollNode = html.pageContentScroll();
				scrollNode.scrollLeft = this.scrollX;
				scrollNode.scrollTop = this.scrollY;
			});
		},

		/**
		 * Enter the full screen mode
		 */
		startup: function() {
			if (this._started) {
				return;
			}

			const {classList} = document.body;
			const scrollNode = html.pageContentScroll();
			this.scrollY = scrollNode.scrollTop;
			this.scrollX = scrollNode.scrollLeft;
			this._started = true;

			classList.add(CSS_FULLSCREEN_FIRST);
			$("#pageHeader, .csi-toolbar-btn-fullScreen").fadeOut(DURATION, () => classList.add(CSS_FULLSCREEN));

			if (routerStore.renderBreadcrumb) {
				$("#pageBreadcrumb").slideUp(DURATION);
			}

			$(".dijitTabController").slideUp(NO_DURATION);
			this._hideOtherViews();
			_resize(this);
			scrollNode.scrollTop = 0;

			this.own(
				watchStoreProperty(browserStore, "fullScreen", () => this._onExitFullScreenMode())
			);
		},

		/** 
		 * Hide other views
		 */
		_hideOtherViews: function() {
			const compositeViews = {
				DataSheet: 1,
				Html: 1,
			};
			const flexHeightViews = [];
			const {view} = this;
			let {domNode, viewParent} = view;

			function forceFlexHeight(someView) {
				if (!someView.flexHeight) {
					flexHeightViews.push(someView);
					someView.set("flexHeight", true);
				}
			}

			forceFlexHeight(view);

			// force parent views to use flex height
			while (viewParent) {
				// hide any toolbar in parent views
				if (viewParent.toolbarNode) {
					viewParent.toolbarNode.domNode.classList.add(CSS_FULLSCREEN_HIDE);
				}

				// if Html view, then hide any siblings
				if (compositeViews[viewParent.defView.getType()]) {
					const contentNode = viewParent.getContentRoot();

					while (domNode !== contentNode) {
						hideSiblings(domNode);
						domNode.classList.add(CSS_FULLSCREEN_CONTAINER);
						domNode = domNode.parentNode;
					}
				}

				forceFlexHeight(viewParent);
				domNode = viewParent.domNode;
				viewParent = viewParent.viewParent;
			}

			this.flexHeightViews = flexHeightViews;
		},

		/** 
		 * Show other views
		 */
		_showOtherViews: function() {
			const nodeList = document.querySelectorAll(`.${CSS_FULLSCREEN_CONTAINER}, .${CSS_FULLSCREEN_HIDE}`);

			for (const domNode of nodeList) {
				domNode.classList.remove(CSS_FULLSCREEN_CONTAINER, CSS_FULLSCREEN_HIDE);
			}

			this.flexHeightViews.forEach((view) => {
				if (view.isValidView()) {
					view.set("flexHeight", false);
				}
			});

			// ensure toolbar is updated (and resized) because of full screen button being hidden;
			// it is possible in data setup to select a new view when in full screen mode, or navigate to
			// another node - in such cases the original view may no longer be valid
			if (this.view.isValidView()) {
				this.view.set("disabled", false);
			}
		}
	});
});